module.exports = __webpack_public_path__ + "media/components/Builder/Library/Modules/Page/Thumbnails/ItemList-3b95153ba0e86f99a09f1cae4068f540.png";